import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import SocialLoginPage from './SocialLoginPage';
import {
    logInUser as logInUserAction,
    linkAccountsOnLogin as linkAccountsOnLoginAction,
    moveBack as moveBackAction,
    clearAuthNotification as clearAuthNotificationAction,
    trackSocialProviderClick as trackSocialProviderClickAction,
} from '../../actions/auth';

import { sendResetPasswordEmail as sendResetPasswordEmailAction } from '../../actions/email';

const _mapStateToProps = ({ authentication }) => ({
    authNotificationOptions: authentication.authNotificationOptions,
    disableRecaptcha3: authentication.disableRecaptcha3,
    email: authentication.email,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    showCaptcha: authentication.displayCaptcha,
    linkedAccountSuccessUrl: authentication.linkedAccountSuccessUrl,
});

const _mapDispatchToProps = {
    onLogInUser: logInUserAction,
    moveBack: moveBackAction,
    handleForgotPassword: sendResetPasswordEmailAction,
    clearAuthNotification: clearAuthNotificationAction,
    onSocialProviderClick: trackSocialProviderClickAction,
    onLinkAccountsOnLogin: linkAccountsOnLoginAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SocialLoginPage),
);
